// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD1swNQtZT8aLMcikMrLLtBhgjx4FkT9lg",
  authDomain: "ecommerceproductdetailsgen22.firebaseapp.com",
  projectId: "ecommerceproductdetailsgen22",
  storageBucket: "ecommerceproductdetailsgen22.firebasestorage.app",
  messagingSenderId: "896072131745",
  appId: "1:896072131745:web:f2944b1559afdf008abce0"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;
 